import { render, staticRenderFns } from "./VehicleSelector.vue?vue&type=template&id=3b287340&"
import script from "./VehicleSelector.vue?vue&type=script&lang=js&"
export * from "./VehicleSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports